export const SET_PALETTE_VARIATION = 'SET_PALETTE_VARIATION';


// WEBPACK FOOTER //
// ./src/core/palettes/action-types.js